import { Button, Tooltip, TextField, Box, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Stack, InputAdornment } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import IdentidadEjemplo from '../IdentidadEjemplo.jpg'
import classes from "../ParticipanteClasess.css";
import { useState } from "react";
import Desplegable from "./Desplegable";
import Autocomplete from '@mui/material/Autocomplete';
import * as React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; // Importa el archivo de localización para español

function CustomDatePicker(props) {
    const today = dayjs();
    const [selectedDate, setSelectedDate] = React.useState(null);
    const [invalidFormat, setInvalidFormat] = React.useState(false);

    const handleDateChange = (date) => {
        if (date && !dayjs(date, "DD/MM/YYYY").isValid()) {
            setInvalidFormat(true);
        } else {
            setInvalidFormat(false);
            setSelectedDate(date);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                id='aval2Nacimiento'
                format={"DD/MM/YYYY"}
                value={selectedDate}
                onChange={handleDateChange}
                slotProps={{
                    textField: {
                        helperText: invalidFormat ? "Formato de fecha incorrecto" : (selectedDate && dayjs(selectedDate).isAfter(today) ? "La fecha seleccionada es mayor a la fecha actual" : null),
                        onChange: { onchange }
                    },
                }}
                maxDate={today}
                {...props}
            />
        </LocalizationProvider>
    );
}

export default function Aval2({ errorsEnviar, setErrors, formulario, onchange, Datepickernacimiento, handleblurAval, handletipovivienda, valorvivienda,
    selectedcivil, handlecivil, selecteddepa, handledepa, selecteddepalaboral, handledepalaboral
}) {

    const [civil, setCivil] = useState('');
    const [selectedIdentidadAval2, setselectedIdentidadAval2] = useState(null);

    const handleDragOverIdentidadSoli = (event) => {
        event.preventDefault();
    };

    const handleDropIdentidadSoli = (event) => {
        event.preventDefault();
        const file = event.dataTransfer.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval2(file);
        } else {
            alert('Por favor suelta un archivo con formato PDF.');
        }
    };

    const handleClickIdentidadSoli = () => {
        document.getElementById('selectedIdentidadSoli').click();
    };

    const handleFileChangeIdentidadSoli = (event) => {
        const file = event.target.files[0];
        if (file && file.type === 'application/pdf') {
            setselectedIdentidadAval2(file);
        } else {
            alert('Por favor seleccione un archivo con formato PDF.');
        }
    };

    const handleChange = (event) => {
        setCivil(event.target.value);
    };

    const defaultProps = {
        options: listadepartamentos,
        getOptionLabel: (option) => option.title,
    };
    const flatProps = {
        options: listadepartamentos.map((option) => option.title),
    };

    const defaultPropsCivil = {
        options: listacivil,
        getOptionLabel: (option) => option.title,
    };
    const flatPropsCivil = {
        options: listacivil.map((option) => option.title),
    };


    const [value, setValue] = React.useState(null);

    const validarSoloNumeros = (event) => {
        // Solo permitir números
        event.target.value = event.target.value.replace(/[^0-9]/g, '');
    };

    const validarSoloLetras = (event) => {
        // Solo permitir letras y espacio
        event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, '');
    };


    /*---------------------FINAL Validación Longitudes Y Campos Vacíos* ---------------*/

    return (
        <>
            <Box>
                <Stack direction="column" style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                    <h3 >IV. DATOS PERSONALES - AVAL 2</h3>
                </Stack>

                <Stack direction="column" spacing={2}>
                    <TextField id="aval2Identidad" placeholder="Ingrese # de identidad" label="Numero de Identidad" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 13 }}
                        value={formulario.aval2Identidad}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Identidad)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Identidad} />

                    <TextField id="aval2Nombres" placeholder="Ingrese el nombre" label="Nombres" variant="outlined" onInput={validarSoloLetras}
                        value={formulario.aval2Nombres}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Nombres)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Nombres} />

                    <TextField id="aval2Apellidos" placeholder="Ingrese los apellidos" label="Apellidos" variant="outlined" onInput={validarSoloLetras}
                        value={formulario.aval2Apellidos}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Apellidos)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Apellidos} />

                    <Datepickernacimiento label="Fecha Nacimiento" id="aval2nacimiento" />

                    <TextField id="aval2Profesion" placeholder="Ingrese profesión u oficio" label="Profesión u Oficio" variant="outlined" onInput={validarSoloLetras}
                        value={formulario.aval2Profesion}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Profesion)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Profesion} />
                </Stack>

                <Stack className={classes.above} direction="row" >
                    <Grid spacing={2} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                        <Box >
                            <FormControl  >
                                <Stack direction="column" marginTop={4} style={{ textAlign: 'center' }}>
                                    {<label><strong>Tipo De Vivienda</strong></label>}
                                </Stack>
                                <RadioGroup row aria-labelledby="Tipo Vivienda" name="tipoVivienda" id="tipoViviendaAval2"
                                    onChange={handletipovivienda} value={valorvivienda}>
                                    <FormControlLabel value="aval2vivienda1" control={<Radio color="error" />} label="Propia" />
                                    <FormControlLabel value="aval2vivienda2" control={<Radio color="error" />} label="Familiar" />
                                    <FormControlLabel value="aval2vivienda3" control={<Radio color="error" />} label="Alquilada" />
                                </RadioGroup>
                            </FormControl>
                        </Box>
                    </Grid>
                </Stack>

                <Stack className={classes.above} direction="column" marginTop={2}>
                    <Grid Container>

                        <Box>
                            <label><strong>Dirección</strong></label>
                            <Box>
                                <Stack direction="column" spacing={2}>
                                    <TextField id="aval2Barrio" placeholder="Ingrese barrio o colonia" label="Barrio/Col." variant="outlined"
                                        value={formulario.aval2Barrio}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Barrio)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Barrio} />

                                    <TextField id="aval2Ave" placeholder="Ingrese avenida" label="Ave." variant="outlined"
                                        value={formulario.aval2Ave}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Ave)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Ave} />

                                    <TextField id="aval2Calle" placeholder="Ingrese # calle" label="Calle." variant="outlined"
                                        value={formulario.aval2Calle}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Calle)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Calle} />

                                    <TextField id="aval2Casa" placeholder="Ingrese # casa" label="Casa No." variant="outlined"
                                        value={formulario.aval2Casa}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Casa)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Casa} />

                                    <TextField id="aval2Ciudad" placeholder="Ingrese la ciudad" label="Ciudad" variant="outlined"
                                        value={formulario.aval2Ciudad}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Ciudad)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Ciudad} />

                                    <Autocomplete
                                        {...defaultProps}
                                        id="aval2Departamento"
                                        value={selecteddepa}
                                        onChange={handledepa}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Ingrese el departamento" label="Departamento" variant="outlined"
                                                error={Boolean(errorsEnviar.aval2Departamento)}
                                                onBlur={handleblurAval}
                                                helperText={errorsEnviar.aval2Departamento} />
                                        )}
                                    />

                                    <Autocomplete
                                        {...defaultPropsCivil}
                                        id="estadocivilAval2"
                                        value={selectedcivil}
                                        onChange={handlecivil}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder="Ingrese estado civil" label="Estado Civil" variant="outlined"
                                                error={Boolean(errorsEnviar.estadocivilAval2)}
                                                onBlur={handleblurAval}
                                                helperText={errorsEnviar.estadocivilAval2} />
                                        )}
                                    />

                                    <TextField id="aval2ReferenciaDomicilio" placeholder="Ingrese referencia del domicilio" label="Referencia Domicilio" variant="outlined"
                                        value={formulario.aval2ReferenciaDomicilio}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2ReferenciaDomicilio)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2ReferenciaDomicilio} />

                                    <TextField id="aval2Fijo" label="Teléfono Fijo" placeholder="Ingrese # de teléfono fijo" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        value={formulario.aval2Fijo}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Fijo)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Fijo} />

                                    <TextField id="aval2Movil" label="Teléfono Movil" placeholder="Ingrese # de teléfono móvil" variant="outlined" onInput={validarSoloNumeros} inputProps={{ maxLength: 8 }}
                                        value={formulario.aval2Movil}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Movil)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Movil} />

                                    <TextField id="aval2Correo" label="Correo Electrónico" placeholder="Ingrese correo electrónico" variant="outlined"
                                        value={formulario.aval2Correo}
                                        onChange={onchange}
                                        error={Boolean(errorsEnviar.aval2Correo)}
                                        onBlur={handleblurAval}
                                        helperText={errorsEnviar.aval2Correo} />
                                </Stack>
                            </Box>
                        </Box>
                    </Grid>
                </Stack>
            </Box>

            <Box>
                <Stack direction="column" style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}>
                    <h3 >V. INFORMACIÓN LABORAL - AVAL 2</h3>
                </Stack>

                <Stack direction="column" spacing={2}>
                    <TextField id="aval2Dependencia" placeholder="Ingrese dependencia laboral" label="Dependencia donde trabaja" variant="outlined"
                        value={formulario.aval2Dependencia}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Dependencia)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Dependencia} />

                    <TextField id="aval2Ramo" placeholder="Ingrese ramo" label="Ramo" variant="outlined"
                        value={formulario.aval2Ramo}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Ramo)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Ramo} />

                    <TextField id="aval2TelefonoTrabajo" placeholder="Ingrese # teléfono" label="Teléfono" variant="outlined" inputProps={{ maxLength: 8 }} onInput={validarSoloNumeros}
                        value={formulario.aval2TelefonoTrabajo}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2TelefonoTrabajo)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2TelefonoTrabajo} />
                    <Box marginTop={2}>
                        <label><strong>Dirección</strong></label>
                        <Box>
                            <Stack direction="column" spacing={2}>
                                <TextField id="aval2BarrioTrabajo" placeholder="Ingrese barrio/colonia" label="Barrio/Col." variant="outlined"
                                    value={formulario.aval2BarrioTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval2BarrioTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2BarrioTrabajo} />

                                <TextField id="aval2AveTrabajo" placeholder="Ingrese avenida" label="Ave." variant="outlined"
                                    value={formulario.aval2AveTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval2AveTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2AveTrabajo} />

                                <TextField id="aval2CalleTrabajo" placeholder="Ingrese # de calle" label="Calle" variant="outlined"
                                    value={formulario.aval2CalleTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval2CalleTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2CalleTrabajo} />

                                <TextField id="aval2CasaTrabajo" placeholder="Ingrese # de casa" label="Casa No." variant="outlined"
                                    value={formulario.aval2CasaTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval2CasaTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2CasaTrabajo} />

                                <TextField id="aval2CiudadTrabajo" placeholder="Ingrese ciudad" label="Ciudad" variant="outlined"
                                    value={formulario.aval2CiudadTrabajo}
                                    onChange={onchange}
                                    error={Boolean(errorsEnviar.aval2CiudadTrabajo)}
                                    onBlur={handleblurAval}
                                    helperText={errorsEnviar.aval2CiudadTrabajo} />

                                <Autocomplete
                                    {...defaultProps}
                                    id="aval2Departamentotrabajo"
                                    value={selecteddepalaboral}
                                    onChange={handledepalaboral}
                                    renderInput={(params) => (
                                        <TextField {...params} placeholder="Ingrese el departamento" label="Departamento" variant="outlined"
                                            error={Boolean(errorsEnviar.aval2Departamentotrabajo)}
                                            onBlur={handleblurAval}
                                            helperText={errorsEnviar.aval2Departamentotrabajo} />
                                    )}
                                />
                            </Stack>
                        </Box>
                    </Box>

                    <TextField id="sueldoMensualAval2" placeholder="Sueldo Mensual" label="Sueldo Mensual" onInput={validarSoloNumeros} variant="outlined"
                        value={formulario.sueldoMensualAval2}
                        onChange={onchange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errorsEnviar.sueldoMensualAval2)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.sueldoMensualAval2} />
                    <TextField id="otrosIngresosAval2" placeholder="Otros Ingresos" label="Otros ingresos (detalle)" onInput={validarSoloNumeros} variant="outlined"
                        value={formulario.otrosIngresosAval2}
                        onChange={onchange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errorsEnviar.otrosIngresosAval2)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.otrosIngresosAval2} />

                    <TextField id="sueldoNetoAval2" label="Sueldo Neto" placeholder="Sueldo Neto" onInput={validarSoloNumeros} variant="outlined"
                        value={formulario.sueldoNetoAval2}
                        onChange={onchange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    L.
                                </InputAdornment>
                            ),
                        }}
                        error={Boolean(errorsEnviar.sueldoNetoAval2)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.sueldoNetoAval2} />

                    <TextField id="aval2Puesto" placeholder="Ingrese el puesto" label="Puesto" variant="outlined"
                        value={formulario.aval2Puesto}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Puesto)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Puesto} />
                    <Box marginTop={2}>
                        <label><strong>Tiempo De Laborar</strong></label>
                    </Box>
                    <TextField id="aval2Years" label="Años" variant="outlined" placeholder="Años"
                        value={formulario.aval2Years}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Years)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Years} />

                    <TextField id="aval2Meses" label="Meses" variant="outlined" placeholder="Meses"
                        value={formulario.aval2Meses}
                        onChange={onchange}
                        error={Boolean(errorsEnviar.aval2Meses)}
                        onBlur={handleblurAval}
                        helperText={errorsEnviar.aval2Meses} />
                </Stack>
            </Box>
            <Box marginTop={5}>
                {<h3>COPIA DE LA IDENTIDAD DEL AVAL 2 EN FORMATO PDF</h3>}
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    onDragOver={handleDragOverIdentidadSoli}
                    onDrop={handleDropIdentidadSoli}
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: '300px',
                            textAlign: 'center',
                            borderColor: selectedIdentidadAval2 ? 'green' : '#a0a0a0',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <Tooltip
                            title={
                                <div style={{ textAlign: 'center' }}>
                                    <p style={{ fontSize: 15, textAlign: 'justify' }}>El archivo pdf debe contener la tarjeta de identidad por ambos lados de la siguiente forma:</p>
                                    <img src={IdentidadEjemplo} alt="Identidad Ejemplo" style={{ width: '200px', height: 'auto' }} />
                                </div>
                            }
                            interactive
                        >
                            <CloudUploadIcon style={{ fontSize: 48, color: 'gray' }} />
                        </Tooltip>
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleClickIdentidadSoli}
                            color="primary"
                            style={{ marginTop: '10px', backgroundColor: '#ECECEC' }}
                        >
                            Seleccionar Identidad En PDF
                        </Button>
                        <input
                            id="selectedIdentidadAval1"
                            type="file"
                            accept=".pdf"
                            style={{ display: 'none' }}
                            onChange={handleFileChangeIdentidadSoli}
                        />
                        {!selectedIdentidadAval2 && <p>Seleccione el archivo PDF</p>}
                        {selectedIdentidadAval2 && <p>Archivo seleccionado: {selectedIdentidadAval2.name}</p>}
                    </Box>
                </Box>
            </Box>
        </>
    );
}

const listadepartamentos = [
    { title: 'Atlantida', },
    { title: 'Colón', },
    { title: 'Comayagua', },
    { title: 'Copán', },
    { title: 'Cortés', },
    { title: 'Choluteca', },
    { title: 'El Paraíso', },
    { title: 'Francisco Morazán', },
    { title: 'Gracias A Dios', },
    { title: 'Intibucá', },
    { title: 'Islas De La Bahía', },
    { title: 'La Paz', },
    { title: 'Lempira', },
    { title: 'Ocotepeque', },
    { title: 'Olancho', },
    { title: 'Santa Bárbara', },
    { title: 'Valle', },
    { title: 'Yoro', },
];

const listacivil = [
    { title: 'Soltero', },
    { title: 'Casado', },
    { title: 'Viudo', },
    { title: 'Divorciado', },
    { title: 'Unión Libre', },
];

const listabancos = [
    { title: 'Banco Atlántida S.A.', },
    { title: 'Banco de Occidente S.A.', },
    { title: 'Banco de Los Trabajadores', },
    { title: 'Banco Financiera Centroamericana S.A. (FICENSA)', },
    { title: 'Banco Hondureño del Café S.A. (BANHCAFE)', },
    { title: 'Banco del País S.A. (BANPAIS)', },
    { title: 'Banco Financiera Comercial Hondureña S.A. (FICOHSA)', },
    { title: 'Banco Lafise Honduras  S.A.', },
    { title: 'Banco Davivienda Honduras S.A.', },
    { title: 'Banco Promérica S.A.', },
    { title: 'Banco de Desarrollo Rural Honduras S.A.', },
    { title: 'Banco Azteca de Honduras S.A.', },
    { title: 'Banco Popular S.A.', },
    { title: 'Banco de América Central Honduras S.A. (BAC) | Honduras', },
    { title: 'Banco de Honduras (Citi Honduras)', },
    { title: 'Banco Nacional de Desarrollo Agrícola (BANADESA)', },
    { title: 'Banco Hondureño para la Producción y la Vivienda (BANHPROVI)', },
];
